import { Component, EventEmitter, Output } from '@angular/core';

@Component({
  standalone: false,
  selector: 'app-change-delivery-deadline',
  templateUrl: './change-delivery-deadline.component.html',
  styleUrls: ['../modal.component.scss']
})

export class ChangeDeliveryDeadlineComponent {
  deliveryDeadline: Date = new Date();

  @Output() readonly responseChanged = new EventEmitter();
  @Output() readonly deliveryDealineChanged = new EventEmitter();

  constructor() {}

  onSelectDate(event: Date): void {
    this.deliveryDeadline = event;
  }

  editDeliveryDeadline(): void {
    this.responseChanged.emit(this.deliveryDeadline);
  }

  emitFalse(): void {
    this.responseChanged.emit(false);
  }
}